import React from 'react'
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { mainURL, prodURL } from '../utils/common';

const Vigilance  = () => {
  const fileDownload=(fileStoreId)=>
  {
    
    let url=`${mainURL}/pwc-db-services/getPortalFiles`
     axios
        .post(url,{"fileId": fileStoreId, "userId": "392" })
        .then((res) => {
            console.log("response is --- ", res);

            if(res && res.data && res.status === 200) {
              const base64 = res.data[0] && res.data[0].base64_data;
              const pdfData = 'data:application/pdf;base64,'+base64;

              let html = '<html>' +
                  '<style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style>' +
                  '<body>' +
                  '<iframe src="' + pdfData + '"></iframe>' +
                  '</body></html>';
                  console.log(html);
              let a = window.open();
              a.document.write(html);
          }
        })
        .catch((e) => {
            // setLoader(false);
            console.log("The error is ", e);
        })
  }
const increaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
      var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
      var fontSize = parseFloat(style); 
      el[i].style.fontSize = (fontSize + 1) + 'px';
    }
  };
  const decreaseFontSizeBy1px =() => {
    var el = document.getElementsByClassName('fontSizeClass');
    for (let i = 0; i < el.length; i++) {
    var style = window.getComputedStyle(el[i], null).getPropertyValue('font-size');
    var fontSize = parseFloat(style); 
    el[i].style.fontSize = (fontSize - 1) + 'px'; 
    }
  };
  const { t, i18n, ready } = useTranslation();
  return (
    <>
  <section id="hero" className="hero hero2">
  <div className="social-media wow slideInDown" style={{ visibility: "visible", animationName: "slideInDown" }}>
        <div className="facebook" rel="ebInfo" title="facebook">
          <a href="https://www.facebook.com/KolkataMunicipalCorporation.official" target="_blank">
            <img src="assets/img/face-book-1.png" alt="alt-image" />
          </a>
        </div>
        <div className="twitter" rel="ebInfo" title="Twitter">
          <a href="https://twitter.com/kmc_kolkata" target="_blank">
            <img src="assets/img/twitter1.png" alt="alt-image" />
          </a>
        </div>
        <div className="support" rel="ebInfo" title="KMC Support">
            <a href="/Contact_Us_Home" target="_blank">
            <img src="assets/img/support.png" alt="alt-image" />
            </a>
        </div>
        <div className="whatsapp" rel="ebInfo" title="Whatsapp">
          <Link to="/Wathsapp" target="_blank">
            <img src="assets/img/social-media.png" alt="alt-image" />
          </Link>
        </div>
      </div>
  
    <div className="carousel-item active">
      <img src="assets/img/inner-bg2.png" className="img-fluid" alt="image" />
      <div className="container">
        
        <div className="section-main-heading2">
          
          <h4 className="fontSizeClass"> </h4>
        </div>
      </div>
    </div>
  </section>
  {/* End Slider */}
  <section className="section inner-pad1">
    <div className="container" >
      <div className="row">
        {/* <div className="col-lg-3">
          <div className="site-menu  min-height-400">
            <nav className="sidebar card py-2">
              <ul className="nav flex-column" id="nav_accordion">
                <li className="nav-item">
                <Link className="nav-link active1 fontSizeClass" to='/HeritageBuildingHome'> {t("Heritage Home")} </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Heritage_Exemption_of_Tax'> {t("Exemption of Tax")} </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Heritage_Heritage_Buildings'> {t("Heritage Buildings")} </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Heritage_Conservation_Architect'> {t("Conservation Architect")} </Link>
                </li>
                <li className="nav-item">
                  <a className="nav-link fontSizeClass" href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'7eb350f2-0c68-454a-ab33-ce5334cec125'}&tenantId=km.kolkata`}> {t("Composition of the Heritage Conservation Committee")} </a>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fontSizeClass" to='/Heritage_Proceedings_of_HCC'> {t("Proceedings of HCC")} </Link>
                </li>
                <li className="nav-item">
                  <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'f13351d7-e7ac-4c98-86d1-f8cb44592d2a'}&tenantId=km.kolkata`}>{t("Action Plan")}</a>
                </li>
                <li className="nav-item">
                 <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'449dca47-c7fa-4ce8-8358-29df3c49c02a'}&tenantId=km.kolkata`}> {t("Parking Policy")}</a>
                </li>
                <li className="nav-item">
                <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'0ff9df4e-6a67-4cbe-84c9-15999895b035'}&tenantId=km.kolkata`}> {t("Measures for prevention of landfill fire")}</a>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" href={`${prodURL}/citizen/withoutAuth/pmu/pond-details/search`}> {t("Ward wise Pond")} </a>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" href={`${prodURL}/citizen/withoutAuth/pmu/heritage-details/search`}> {t("Ward Wise Heritage Building")} </a>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" href={`${prodURL}/contact-us/departmentContacts`}> {t("Contact")} </a>
                </li>

                <li className="nav-item">
                  <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'18092726-2a59-4f3c-8a94-891f18042026'}&tenantId=km.kolkata`}> {t("Activities Permitted under NCAP")} </a>
                </li>

                <li className="nav-item">
                    <button type="button" className="btn" data-toggle="collapse" data-target="#demo2">{t("Swachh Vayu Survekshan")} <i className="bi bi-chevron-down" /></button>
                    <div id="demo2" className="collapse">
                        <a className="nav-link fontSizeClass" href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'4b63609e-a3e0-4c35-9b73-ddf88bb11b28'}&tenantId=km.kolkata`}> 1. {t("Self assessed scores & CPCB scores")} </a>
                        <a className="nav-link fontSizeClass" href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'18092926-2a59-4f3c-8a94-891f18042026'}&tenantId=km.kolkata`}> 2. {t("Self assessment reports of Kolkata city2023")} </a>
                        <a className="nav-link fontSizeClass" href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'31a111f2-c956-4d5e-af38-3dadeeb50de2'}&tenantId=km.kolkata`}> 3. {t("Swachh Vayu Survekshan 2023 Rank")} </a>
                        <a className="nav-link fontSizeClass" href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'b3554452-fb91-4c33-9ea9-75165448535d'}&tenantId=km.kolkata`}> 4. {t("Swachh Vayu Survekshan")} </a>
                    </div>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" href='http://emis.wbpcb.gov.in/airquality/citizenreport.do' target={'_blank'}> {t("Air quality status")} </a>
                </li>
                <li className="nav-item">
                <a className="nav-link fontSizeClass" href='http://emis.wbpcb.gov.in/emis/category.do' target={'_blank'}> {t(" Industry categorisation")} </a>
                </li>
                <li className="nav-item"><a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${'18092826-2a59-4f3c-8a94-891f18042026'}&tenantId=km.kolkata`}> {t("FINAL District Environment plan KMC 2021")} </a>
                </li>

                 
              </ul>
            </nav>
          </div>
        </div> */}

        <div className="inner-title2" >
          <h3 className="fontSizeClass">{t("Office Of The IGP & Vigilance Authority")} </h3>
        </div> 

                <div className="col-lg-6 col-md-6 pt-3">
                  <div className="about-head1">
                    <h4 className="fontSizeClass"> Location of the Office </h4>
                       <span className='ofic1'>
                       Office of the Inspector General of Police & Vigilance Authority <br/> 
                       The Kolkata Municipal Corporation <br/> 
                       New Market Building, Phase- I (HUDCO) 8th Floor <br/> 
                       15N, Nellie Sengupta Sarani, Kolkata-700087.
                    </span>                                                           
                  </div>   
                </div>
                <div className="col-lg-6 col-md-6 pt-3">
                  <div className="about-head1">
                    <h4 className="fontSizeClass"> Contact Details </h4>
                       <span className='ofic1'>
                       Inspector General of Police & Vigilance Authority, The Kolkata Municipal Corporation <br/>
                       <strong> Fax No. 2252-5555,Telephone No. 2252-5050 </strong>
                    </span> 
                    <span className='ofic1'>
                    Deputy Superintendent of Police, W.B. & Vigilance Officer, The Kolkata Municipal Corporation <br/>
                    <strong> Telephone No. 2252-8888  </strong>
                    </span>                                                           
                  </div>   
                </div>

          </div>

      </div>
  </section>
</>

  )
}

export default Vigilance